import { GET, PUT } from '../request'

export const getUsuario = () => GET('/api/agora/personal/usuario')

export const updateAcademiaUsuario = ({ id, centro }) =>
  PUT('/api/agora/personal/usuario', { id, centro })
